import _slugify from 'slugify';

export var enumerate = function enumerate() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var obj = {};
  args.forEach(function (arg, i) {
    obj[obj[arg] = i] = arg;
  });
  return obj;
};

// eslint-disable-next-line import/prefer-default-export
export var slugify = function slugify(s) {
  return _slugify(s, {
    remove: /[$*_+~.()'"!\-:@]/g,
    lower: true
  });
};